import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PageBlock, Stack, vars } from '@etg/wings';
import { useSnowplowTracking, useProperty, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { SelfServiceRebookingTraveler } from '@eti/types';
import { Helmet } from 'react-helmet';
import TripReminder from '../../../widgets/trip-reminder/containers/TripReminderContainer';
import SearchFormPanel from '../../../common/search-form-panel/SearchFormPanel';
import { StartPageDestinationPageContent } from '../../../common/components/StartPageDestinationPageContent';
import HeaderTakeOverBanner from '../../../common/components/HeaderTakeOverBanner';
import { useGetBlue, eventTypes } from '../../../utils/useGetBlue';
import RedirectClosedBrandModal from './RedirectClosedBrandModal';
import StartPageContent from './StartPageContent';

const blockStyles = css`
  background-color: ${vars.colors.page.background.secondary};
`;

const StartPage = ({ rebookingData }) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  useGetBlue(eventTypes.VISIT);

  useEffect(() => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({ category: 'Start', action: 'Seen', label: 'Page' });
    }
  }, [isSnowplowTrackingEnabled, sendTrackEvent]);

  const shouldShowHeaderTakeOverBanner =
    p('StartPage.HeaderTakeOver.Enabled') && p('StartPage.HeaderTakeOver.Position') === 'below';
  const shouldShowStartPageAdForm = p('IbeClient.Adform.StartPage.Enabled');
  return (
    <>
      <Helmet title={t('PageTitle.rf.start.action')} />
      <SearchFormPanel
        isPopunderEnabled={p('SearchForm.Popunder.BookingCom.Enabled')}
        panelHeaderTitle={t('StartPage.PanelHeader.Title')}
        rebookingData={rebookingData}
      />
      <StartPageDestinationPageContent isStartPage />
      {(shouldShowHeaderTakeOverBanner || shouldShowStartPageAdForm) && (
        <PageBlock className={blockStyles} withPaddingY>
          <Stack spacing={32}>
            {shouldShowHeaderTakeOverBanner && <HeaderTakeOverBanner />}
            {shouldShowStartPageAdForm && <StartPageContent />}
          </Stack>
        </PageBlock>
      )}
      <RedirectClosedBrandModal />
      <TripReminder />
    </>
  );
};

StartPage.propTypes = {
  rebookingData: PropTypes.shape({
    criteria: PropTypes.arrayOf(PropTypes.string),
    formConstraints: PropTypes.shape({
      passengers: PropTypes.shape({
        isDisabled: PropTypes.bool,
        maxNumberOfTravelers: PropTypes.number,
      }),
    }),
    initialValues: PropTypes.shape({
      passengers: PropTypes.shape({
        adults: PropTypes.number,
        children: PropTypes.number,
        infants: PropTypes.number,
      }),
    }),
    travelers: PropTypes.arrayOf(SelfServiceRebookingTraveler),
  }),
};

export default StartPage;
